/**
 * First/last name fields: Unicode letters, spaces, and tilde (˜).
 * Trimming is applied via setValueAs so submitted values have no leading/trailing spaces.
 */
const PERSON_NAME_INVALID_CHARS = /[^\p{L}\s˜]/gu;

export const PERSON_NAME_PATTERN = /^[\p{L}\s˜]+$/u;

export function trimPersonName(value: unknown): string {
    return typeof value === 'string' ? value.trim() : '';
}

export function sanitizePersonNameInput(raw: string): string {
    return raw.replace(PERSON_NAME_INVALID_CHARS, '');
}

export function getPersonNameRegisterOptions(requiredMessage = 'Required') {
    return {
        required: requiredMessage,
        setValueAs: trimPersonName,
        validate: (value: string) => {
            if (!value) return true;
            return (
                PERSON_NAME_PATTERN.test(value) ||
                'Only letters, spaces, ˜, and ñ are allowed'
            );
        },
    };
}
